import { render, staticRenderFns } from "./CompareTableColumnsViewpoints.vue?vue&type=template&id=3b5e3fc6&scoped=true&"
import script from "./CompareTableColumnsViewpoints.vue?vue&type=script&lang=ts&"
export * from "./CompareTableColumnsViewpoints.vue?vue&type=script&lang=ts&"
import style0 from "./CompareTableColumnsViewpoints.vue?vue&type=style&index=0&id=3b5e3fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5e3fc6",
  null
  
)

export default component.exports